<template>
  <v-row>
    <v-col class="px-2" cols="12" sm="6" md="5">
      <v-row no-gutters>
        <v-badge color="accent" overlap>
          <template v-slot:badge>
            <v-icon color="white" v-if="countFilters === 0" @click="dialog = true">fa-plus</v-icon>
            <span v-else style="color: white" @click="dialog = true">{{ countFilters }}</span>
          </template>
          <v-tooltip bottom>
            {{ $t("global.filters") }}
            <template #activator="{ on }">
              <v-btn icon @click="dialog = true" v-on="on">
                <v-icon>
                  fa-filter
                </v-icon>
              </v-btn>
            </template>
          </v-tooltip>
        </v-badge>
        <div v-if="countFilters > 0" style="margin-top: 10px;">
          {{ $t("global.filters") }}: {{ countFilters }} {{ $t("global.active") }} <v-btn icon @click="clearFilters"><v-icon color="grey">clear</v-icon></v-btn>
        </div>
        <v-checkbox class="ml-3 mt-1" :label="$t('global.expandAll')" v-model="contextShowAll" />
      </v-row>
    </v-col>

    <v-spacer />
    <v-col class="px-2" cols="12" sm="6" md="3">
      <v-row no-gutters>
        <booking-column-select :available-columns.sync="availableColumns" :selected-columns.sync="contextSelectedColumns" style="max-width: 80%" />
        <v-tooltip bottom v-if="downloadable">
          {{ $t("global.downloadFile") }}
          <template v-slot:activator="{ on }">
            <v-btn :disabled="$store.getters['Ajax/loading']" @click="$emit('download')" icon v-on="on" large class="mt-3">
              <v-icon large>cloud_download</v-icon>
            </v-btn>
          </template>
        </v-tooltip>
      </v-row>
    </v-col>
    <v-dialog v-model="dialog" max-width="1200px">
      <v-card class="pa-3">
        <v-card-title>
          <span class="headline">
            {{ $t("global.filters") }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="6" class="py-0">
              <v-row no-gutters>
                <date-picker
                  prepend-icon="fa-calendar"
                  v-if="typeof filters.fromDate !== 'undefined'"
                  :model.sync="contextFilters.fromDate"
                  :clearable="true"
                  :label="$t('global.fromDate')"
                  class="px-2"
                  :placeholder="$t('global.any')"
                />
                <date-picker
                  v-if="typeof filters.toDate !== 'undefined'"
                  prepend-icon="fa-calendar"
                  :model.sync="contextFilters.toDate"
                  :clearable="true"
                  :label="$t('global.toDate')"
                  class="px-2"
                  :placeholder="$t('global.any')"
                />
              </v-row>
              <v-row no-gutters>
                <date-picker
                  prepend-icon="fa-calendar"
                  v-if="typeof filters.fromIssueDate !== 'undefined'"
                  :model.sync="contextFilters.fromIssueDate"
                  :clearable="true"
                  :label="$t('booking.issueDate') + ' ' + $t('global.fromDate')"
                  class="px-2"
                  :placeholder="$t('global.any')"
                />
                <date-picker
                  v-if="typeof filters.toIssueDate !== 'undefined'"
                  prepend-icon="fa-calendar"
                  :model.sync="contextFilters.toIssueDate"
                  :clearable="true"
                  :label="$t('booking.issueDate') + ' ' + $t('global.toDate')"
                  class="px-2"
                  :placeholder="$t('global.any')"
                />
              </v-row>
              <v-row no-gutters>
                <date-picker
                  prepend-icon="fa-calendar"
                  v-if="typeof filters.fromSaleDate !== 'undefined'"
                  :model.sync="contextFilters.fromSaleDate"
                  :clearable="true"
                  :label="$t('booking.saleDate') + ' ' + $t('global.fromDate')"
                  class="px-2"
                  :placeholder="$t('global.any')"
                />
                <date-picker
                  v-if="typeof filters.toSaleDate !== 'undefined'"
                  prepend-icon="fa-calendar"
                  :model.sync="contextFilters.toSaleDate"
                  :clearable="true"
                  :label="$t('booking.saleDate') + ' ' + $t('global.toDate')"
                  class="px-2"
                  :placeholder="$t('global.any')"
                />
              </v-row>
              <v-col v-if="typeof filters.selectedTypes !== 'undefined'" class="py-0">
                <v-autocomplete
                  multiple
                  v-model="contextFilters.selectedTypes"
                  prepend-icon="fa-hand-holding-usd"
                  :label="$t('global.serviceTypes')"
                  small-chips
                  :items="availableServiceTypes"
                  item-text="name"
                  item-value="type"
                  :placeholder="$t('global.any')"
                  clearable
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index <= 3" color="primary" text-color="white" small>
                      <span v-if="item.name.length < 13">
                        {{ item.name }}
                      </span>
                      <span v-else> {{ item.name.substring(0, 13) }}... </span>
                    </v-chip>
                    <span v-if="index === 4" class="grey--text caption">(+{{ contextFilters.selectedTypes.length - 4 }} {{ $t("global.others") }})</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col v-if="typeof filters.passengers !== 'undefined'" class="py-0">
                <v-autocomplete
                  multiple
                  v-if="typeof filters.passengers !== 'undefined'"
                  v-model="contextFilters.passengers"
                  prepend-icon="fa-users"
                  :label="$t('global.passengers')"
                  small-chips
                  :items="availablePassengers"
                  :placeholder="$t('global.any')"
                  clearable
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index <= 2" color="primary" text-color="white" small>
                      <span v-if="item.length < 18">
                        {{ item }}
                      </span>
                      <span v-else> {{ item.substring(0, 18) }}... </span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption">(+{{ contextFilters.passengers.length - 3 }} {{ $t("global.others") }})</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col v-if="typeof filters.organizationUnit !== 'undefined'" class="py-0">
                <v-autocomplete
                  multiple
                  v-model="contextFilters.organizationUnit"
                  prepend-icon="fa-sitemap"
                  :label="$t('booking.organizationUnit')"
                  small-chips
                  :items="availableOrganizationUnits"
                  :placeholder="$t('global.any')"
                  clearable
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index <= 2" color="primary" text-color="white" small>
                      <span v-if="item.length < 18">
                        {{ item }}
                      </span>
                      <span v-else> {{ item.substring(0, 18) }}... </span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption">(+{{ contextFilters.organizationUnit.length - 3 }} {{ $t("global.others") }})</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col v-if="typeof filters.reservationNumbers !== 'undefined'" class="py-0">
                <v-autocomplete
                  multiple
                  v-model="contextFilters.reservationNumbers"
                  prepend-icon="fa-clipboard-list"
                  :label="$t('global.reservationNumber')"
                  small-chips
                  :items="availableReservationNumbers"
                  :placeholder="$t('global.any')"
                  clearable
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index <= 2" color="primary" text-color="white" small>
                      <span v-if="item.length < 18">
                        {{ item }}
                      </span>
                      <span v-else> {{ item.substring(0, 18) }}... </span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption">(+{{ contextFilters.reservationNumbers.length - 3 }} {{ $t("global.others") }})</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col v-if="typeof filters.isDomestic !== 'undefined'" class="py-0">
                <v-select
                  prepend-icon="fa-globe-americas"
                  :label="$t('global.travelType')"
                  v-if="typeof filters.isDomestic !== 'undefined'"
                  v-model="contextFilters.isDomestic"
                  :items="isDomesticFilter"
                />
              </v-col>
              <v-col v-if="typeof filters.grossAbove !== 'undefined'" class="py-0">
                <v-row no-gutters>
                  <v-col class="px-2" cols="6">
                    <amount-input
                      :label="$t('booking.servicePriceAbove')"
                      prepend-icon="fa-money-bill-wave"
                      :model.sync="contextFilters.grossAbove"
                      clearable
                      :placeholder="$t('global.noLimit')"
                    />
                  </v-col>
                  <v-col class="px-2" cols="6">
                    <amount-input
                      :label="$t('booking.servicePriceBellow')"
                      prepend-icon="fa-money-bill-wave"
                      :model.sync="contextFilters.grossUnder"
                      clearable
                      :placeholder="$t('global.noLimit')"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
            <v-col cols="12" sm="6">
              <fieldset class="custom-fieldset">
                <legend>{{ $t("booking.refersToGroup") }}</legend>
                <v-col v-if="typeof filters.countAbove !== 'undefined'">
                  <v-row no-gutters>
                    <v-col class="px-2" cols="6">
                      <amount-input
                        :label="$t('booking.countAbove')"
                        prepend-icon="fa-calculator"
                        :model.sync="contextFilters.countAbove"
                        clearable
                        :placeholder="$t('global.noLimit')"
                      />
                    </v-col>
                    <v-col class="px-2" cols="6">
                      <amount-input
                        :label="$t('booking.countBellow')"
                        prepend-icon="fa-calculator"
                        :model.sync="contextFilters.countUnder"
                        clearable
                        :placeholder="$t('global.noLimit')"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col v-if="typeof filters.grossSumAbove !== 'undefined'">
                  <v-row no-gutters>
                    <v-col class="px-2" cols="6">
                      <amount-input
                        :label="$t('booking.grossAmountAbove')"
                        prepend-icon="fa-money-bill-wave"
                        :model.sync="contextFilters.grossSumAbove"
                        :placeholder="$t('global.noLimit')"
                        clearable
                      />
                    </v-col>
                    <v-col class="px-2" cols="6">
                      <amount-input
                        :label="$t('booking.grossAmountBellow')"
                        prepend-icon="fa-money-bill-wave"
                        :model.sync="contextFilters.grossSumUnder"
                        :placeholder="$t('global.noLimit')"
                        clearable
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col v-if="typeof filters.grossAverageAbove !== 'undefined'">
                  <v-row no-gutters>
                    <v-col class="px-2" cols="6">
                      <amount-input
                        :label="$t('booking.averagePriceAbove')"
                        prepend-icon="fa-chart-line"
                        :model.sync="contextFilters.grossAverageAbove"
                        :placeholder="$t('global.noLimit')"
                        clearable
                      />
                    </v-col>
                    <v-col class="px-2" cols="6">
                      <amount-input
                        :label="$t('booking.averagePriceBellow')"
                        prepend-icon="fa-chart-line"
                        :model.sync="contextFilters.grossAverageUnder"
                        :placeholder="$t('global.noLimit')"
                        clearable
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </fieldset>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="dialog = false">{{ $t("global.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import DatePicker from "../../CustomInputComponents/DatePicker";
import AmountInput from "../../CustomInputComponents/AmountInput";
import BookingColumnSelect from "../BookingColumnSelect";
export default {
  name: "BookingReportExtendedFilters",
  components: { BookingColumnSelect, AmountInput, DatePicker },
  props: {
    selectedColumns: {
      required: true
    },
    availableColumns: {
      required: true
    },
    showAll: {
      required: true
    },
    filters: {
      required: true
    },
    downloadable: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    availableServiceTypes: [],
    availablePassengers: [],
    availableOrganizationUnits: [],
    availableReservationNumbers: [],
    dialog: false,
    emptyFilters: null
  }),
  methods: {
    downloadServiceTypes() {
      this.axios.get("booking/report/get-filter-data").then(resp => {
        this.availableServiceTypes = resp.data.available_service_types;
        this.availablePassengers = [];
        for (let passenger of resp.data.available_passengers) {
          this.availablePassengers.push(passenger.passengers_names);
        }
        this.availableOrganizationUnits = [];
        for (let organizationUnit of resp.data.available_organization_units) {
          this.availableOrganizationUnits.push(organizationUnit.organization_unit);
        }
        this.availableReservationNumbers = [];
        for (let reservationNumber of resp.data.available_reservation_numbers) {
          this.availableReservationNumbers.push(reservationNumber.reservation_number);
        }
      });
    },
    clearFilters() {
      this.$emit("update:filters", JSON.parse(JSON.stringify(this.emptyFilters)));
    }
  },
  created() {
    this.emptyFilters = JSON.parse(JSON.stringify(this.filters));
    this.downloadServiceTypes();
  },
  computed: {
    countFilters() {
      let count = 0;
      for (let prop in this.filters) {
        if (this.filters[prop] !== null && Array.isArray(this.filters[prop]) && this.filters[prop].length > 0) {
          count++;
          // eslint-disable-next-line no-extra-boolean-cast
        } else if (this.filters[prop] !== null && this.filters[prop] !== "" && !Array.isArray(this.filters[prop])) {
          count++;
        }
      }
      return count;
    },
    isDomesticFilter() {
      return [
        { value: null, text: this.$t("global.any") },
        { value: 1, text: this.$t("global.domestic") },
        { value: 0, text: this.$t("global.foreign") }
      ];
    },
    contextFilters: {
      get() {
        return this.filters;
      },
      set(val) {
        this.$emit("update:filters", val);
      }
    },
    contextShowAll: {
      get() {
        return this.showAll;
      },
      set(val) {
        this.$emit("update:showAll", val);
      }
    },
    contextFromDate: {
      get() {
        return this.fromDate;
      },
      set(val) {
        this.$emit("update:fromDate", val);
      }
    },
    contextToDate: {
      get() {
        return this.toDate;
      },
      set(val) {
        this.$emit("update:toDate", val);
      }
    },
    contextSelectedTypes: {
      get() {
        return this.selectedTypes;
      },
      set(val) {
        this.$emit("update:selectedTypes", val);
      }
    },
    contextSelectedColumns: {
      get() {
        return this.selectedColumns;
      },
      set(val) {
        this.$emit("update:selectedColumns", val);
      }
    },
    contextAvailableColumns: {
      get() {
        return this.availableColumns;
      },
      set(val) {
        this.$emit("update:availableColumns", val);
      }
    }
  }
};
</script>

<style scoped></style>
